import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-2 sm:px-0 py-2"
}
const _hoisted_2 = { class: "font-semibold text-gray-700 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_details_category_sub = _resolveComponent("video-details-category-sub")!

  return (Array.isArray(_ctx.categories) && _ctx.categories.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category.id,
            class: "mb-2"
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(category.name), 1),
            _createVNode(_component_video_details_category_sub, {
              subs: category.video_category_subs
            }, null, 8, ["subs"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}